const earlyLateSliderSections = document.querySelectorAll(".early-vs-late");

earlyLateSliderSections.forEach((section) => {
  const sliderDiv = section.querySelector(".early-late-slider");
  //const slides = section.querySelectorAll(".early-slider > div");
  //   const navs = section.querySelectorAll(".nav");
  const slider = tns({
    container: sliderDiv,
    // item
    items: 1.2,
    autoplay: false,
    controls: true,
    controlsContainer: section.querySelector(".early-slider-controls"),
    nav: false,
    loop: false,
    responsive: {
      600: {
        fixedWidth: 400,
      },
      1024: {
        disable: true,
      }
    },
  });
});
